<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import Topbar from "@/components/TheTopbar.vue";
import Sidebar from "@/components/TheSidebar.vue";

@Component({ components: { Topbar, Sidebar } })
export default class App extends Vue {}
</script>

<style lang="scss"></style>
